import {defineStore} from "pinia";
import {ref} from "vue";
import {getProjectServiceOrderList, getProjectTaskList} from "@/apis/work-order-api";

// 项目任务单表（项目表） 列表
const projectTaskData = ref([]);
// 项目任务单表（项目表） Map key:ID
const projectTaskDataIdMap = ref(new Map());

// 项目服务单 列表
const projectServiceOrderData = ref([]);
// 项目服务单 Map key:ID
const projectServiceOrderDataIdMap = ref(new Map());

export const useProjectTaskDataStore = defineStore('projectTaskData', () => {
    const initProjectTaskData = () => {
        getProjectTaskList().then((res) => {
            projectTaskData.value = res.data;
            handleProjectTaskDataIdMap()
        });
    };
    return  {
        // 初始化所有数据
        initProjectTaskData,
        projectTaskData,
        projectTaskDataIdMap
    }
})
export const useProjectServiceOrderStore = defineStore('projectServiceOrderData', () => {
    const initProjectServiceOrderData = () => {
        getProjectServiceOrderList().then((res) => {
            projectServiceOrderData.value = res.data;
            handleProjectServiceOrderDataIdMap()
        });
    };
    return  {
        // 初始化所有数据
        initProjectServiceOrderData,
        projectServiceOrderData,
        projectServiceOrderDataIdMap
    }
})

function handleProjectTaskDataIdMap() {
    projectTaskDataIdMap.value = new Map(projectTaskData.value.map(item => [item.id, item]));
}

function handleProjectServiceOrderDataIdMap() {
    projectServiceOrderDataIdMap.value = new Map(projectServiceOrderData.value.map(item => [item.id, item]));
}